import { FC } from "react";
import { OrganizationTeamsView } from "../../../../../../../../../../modules/preferences/views/organization-teams-view/OrganizationTeamsView";

export const OrganizationTeamsRoute: FC = () => {
    return (
        <OrganizationTeamsView />
    )
}